import { useFetchDashboard } from '../../api/dashboard';
import React from 'react';
import Dashboard from './Dashboard';

export default function DashboardAsync() {
  const { data } = useFetchDashboard();

  return <Dashboard data={data} />;
}
